import { Flex, FlexProps } from '@bitrise/bitkit';
import React, { FunctionComponent } from 'react';

interface Props extends FlexProps {
  fullWidth?: boolean;
}

const PageContent: FunctionComponent<Props> = (props) => {
  const { fullWidth, ...rest } = props;

  return <Flex {...rest} className="Page__content" maxWidth={fullWidth ? undefined : '97.5rem'} />;
};

export default PageContent;
